import { render, staticRenderFns } from "./PromoCodesModal.vue?vue&type=template&id=0950a283&"
import script from "./PromoCodesModal.vue?vue&type=script&lang=ts&"
export * from "./PromoCodesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports